import LoginComponent from '../template/pages/auth/Login';

const AuthRoutes = [
    { path: '', component: <LoginComponent /> }
];

export default AuthRoutes;